import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openProfile, setLogout } from "features/authSlice";
import { useLoanSidebarData } from "hooks/useLoanSidebarData";
import { getLoanTypeIcon } from "utilities/loan-sidebar/getLoanTypeIcon";
import { deleteAllFiles } from "utilities/files";
import LoanCentricSidebarNavView from "./LoanCentricSidebarNavView";

export interface LoanCentricSidebarNavProps {
  readonly onLoanClick?: (loanId: string) => void;
}

export default function LoanCentricSidebarNav({ onLoanClick }: LoanCentricSidebarNavProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loans, isLoading } = useLoanSidebarData();

  const loanItems = useMemo(
    () =>
      loans.map((loan) => ({
        id: loan.id,
        label: loan.label,
        baseState: loan.baseState,
        isActive: loan.isActive,
        icon: getLoanTypeIcon(),
      })),
    [loans],
  );

  const profileItems = useMemo(
    () => [
      {
        id: "settings",
        label: "Settings",
        onClick: () => dispatch(openProfile()),
      },
      {
        id: "logout",
        label: "Logout",
        onClick: async () => {
          await deleteAllFiles();
          dispatch(setLogout());
          navigate("/");
        },
      },
    ],
    [dispatch, navigate],
  );

  return (
    <LoanCentricSidebarNavView
      loans={loanItems}
      profileItems={profileItems}
      isLoading={isLoading}
      onLoanClick={onLoanClick}
    />
  );
}
